import { Icon } from "../../icons";
import { BuzerIcon } from "../../BuzerIcons";
import { Avatar } from "./Avatar";
import "./bottomnav.css";

// Spodná navigácia — plávajúca lišta s vykrojeným stredom a stredovým „+" (FAB).
// Sloty: plameň (Dnes) · graf (Prehľad) · kalendár (Organizér) · [+ FAB] · ľudia (Priatelia)
//        · avatar (Účet) · bodky (Viac).
// active = kľúč aktívnej sekcie; onTab(key) prepne; me = používateľ pre avatar (rámik+koruna).
// fabHandlers = long-press handlery FAB-u, onFab = krátky ťuk (Vytvoriť), fabTourAttr = data-tour.
// onMore = otvorí ponuku „Viac" (obchod · pomoc · nahlásiť chybu · odhlásiť); moreOpen = jej stav.
export function BottomNav({ active, onTab, me, planCount = 0, friendsCount = 0, fabHandlers, onFab, fabTourAttr, onMore, moreOpen }) {
  const item = (key, icon, label, count = 0, size = 22) => (
    <button type="button" onClick={() => onTab(key)} aria-label={label}
      aria-current={active === key ? "page" : undefined}
      className={`bz-bnav__btn${active === key ? " bz-bnav__btn--on" : ""}`}>
      <BuzerIcon name={icon} size={size} color="currentColor" />
      {count > 0 && <span className="bz-countbadge bz-bnav__badge">{count > 99 ? "99+" : count}</span>}
    </button>
  );
  return (
    <nav className="bz-bnav bz-bnav--seven" aria-label="Hlavná navigácia">
      <div className="bz-bnav__wrap" data-tour="nav">
        <div className="bz-bnav__bar" />
        <div className="bz-bnav__row">
          <div className="bz-bnav__cell">{item("dnes", "flame", "Dnes", 0, 23)}</div>
          <div className="bz-bnav__cell">{item("prehlad", "chart", "Prehľad")}</div>
          <div className="bz-bnav__cell">{item("plan", "calendar", "Organizér", planCount)}</div>
          <div className="bz-bnav__cell bz-bnav__cell--gap" />
          <div className="bz-bnav__cell">{item("priatelia", "people", "Priatelia", friendsCount)}</div>
          <div className="bz-bnav__cell">
            <button type="button" onClick={() => onTab("profil")} aria-label="Účet"
              aria-current={active === "profil" ? "page" : undefined}
              className={`bz-bnav__btn bz-bnav__btn--avatar${active === "profil" ? " bz-bnav__btn--on" : ""}`}>
              <Avatar user={me} size={27} />
            </button>
          </div>
          <div className="bz-bnav__cell">
            <button type="button" onClick={onMore} aria-label="Viac" aria-haspopup="menu"
              aria-expanded={moreOpen ? "true" : "false"}
              className={`bz-bnav__btn${moreOpen ? " bz-bnav__btn--on" : ""}`}>
              <BuzerIcon name="dots" size={22} color="currentColor" />
            </button>
          </div>
        </div>
        <button type="button" onClick={onFab} {...(fabHandlers || {})} {...(fabTourAttr || {})}
          className="bz-bnav__fab" aria-label="Vytvoriť (podrž pre AI asistenta)"
          title="Ťuk = Vytvoriť · podrž = AI asistent">
          <Icon name="add" size={25} color="var(--on-ember)" stroke={2.6} />
        </button>
      </div>
    </nav>
  );
}
